import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  CUSTOMERS_FILTER_REQUEST,
  CUSTOMERS_FILTER_SUCCESS,
  CUSTOMERS_FILTER_FAILURE,
  CUSTOMERS_FILTER_CLEAR,
  CUSTOMERS_FILTER_DELETE,
  CUSTOMERS_FILTER_SET,
  CUSTOMERS_FILTER_UPDATE,
} from 'app/actions/reports/filters/customers';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const customers = (state = defaultState, { type, payload }) => {
  switch (type) {
    case CUSTOMERS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case CUSTOMERS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case CUSTOMERS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case CUSTOMERS_FILTER_CLEAR: {
      return defaultState;
    }
    case CUSTOMERS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case CUSTOMERS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case CUSTOMERS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default customers;
